module.exports = __webpack_public_path__ + "img/cold-ammonia-machine.2c4647d2.jpg";